
export default {
    state: {
        basket: []
    },
    
    getters: {
        shoppingBasket(state) {
            return state.basket;
        }
    },
    
    actions: {
        addProductToBasket(context, item) {
            context.commit("addProductToBasket", item);
        },
        
        removeProductFromBasket(context, item) {
            context.commit("removeProductFromBasket", item);
        }
    },
    
    mutations: {
        addProductToBasket(state, payload) {
            if (state.basket.find(item => item.uid === payload.uid)) return;
            
            state.basket.push(payload);
        },
        
        removeProductFromBasket(state, payload) {
            state.basket = state.basket.filter(item => item.uid !== payload.uid);
        }
    }
}